import React from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/img/logo.png";
import steqyema from "../assets/img/steqeyma.png";
import zymfentra from "../assets/img/Zymfentra_Logo_SC120mg.png";

const Header = () => {
  const location = useLocation();

  const getLineLayer = () => {
    if (location.pathname.includes("steqeyma"))
      return "line-layer-steqeyma-desktop";
    if (location.pathname.includes("zymfentra"))
      return "line-layer-zymfentra-desktop";
    return "line-layer-desktop";
  };

  const isPaysign =
    location.pathname === "/entry/steqeyma" ||
    location.pathname === "/" ||
    location.pathname === "/inquiry-form/steqeyma" ||
    location.pathname.includes("zymfentra");

  return (
    <header className={isPaysign ? "header2" : "header"}>
      <Container fluid>
        <div className="header-content">
          <div className="logo2">
            <Link to="/">
              <img src={Logo} alt="logo" className="celltrion-cares-logo" />
            </Link>
            {location.pathname.includes("steqeyma") && (
              <>
                <div className="horizontal-line" />
                <Link to="/entry/steqeyma">
                  <img
                    className="steqeyma-logo"
                    src={steqyema}
                    alt="line-layer"
                  />
                </Link>
              </>
            )}

            {location.pathname.includes("zymfentra") && (
              <>
                <div className="horizontal-line" />
                <Link to="/entry/zymfentra">
                  <img
                    className="steqeyma-logo"
                    src={zymfentra}
                    alt="line-layer"
                  />
                </Link>
              </>
            )}
          </div>
          {isPaysign && (
            <>
              {/* Desktop Button (inside header-content) */}
              <div className="header-button desktop-only">
                <a
                  href="https://celltrionconnect.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="header-button theme-btn"
                >
                  Visit Celltrion CONNECT<sup className="reg">&reg;</sup>
                </a>
              </div>
            </>
          )}
        </div>
      </Container>
      {isPaysign && (
        <>
          <div className={getLineLayer()} />

          {/* Mobile Button (below line layer) */}
          <div className="header-button mobile-only">
            <a
              href="https://celltrionconnect.com"
              target="_blank"
              rel="noopener noreferrer"
              className="header-button theme-btn"
            >
              Visit Celltrion CONNECT<sup className="reg">&reg;</sup>
            </a>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
